var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.701,
    height: 59.701,
    viewBox: "0 0 59.701 59.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1518",
    "data-name": "Ellipse 1518",
    cx: 29.851,
    cy: 29.851,
    r: 29.851,
    transform: "translate(0 0)",
    fill: "#32ba7c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_164579",
    "data-name": "Path 164579",
    d: "M188.8,177.425l15.349,15.349a29.831,29.831,0,0,0,22.129-28.815v-.847L214.225,152Z",
    transform: "translate(-166.577 -134.108)",
    fill: "#0aa06e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25039",
    "data-name": "Group 25039",
    transform: "translate(10.029 14.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164580",
    "data-name": "Path 164580",
    d: "M105.775,212.642a3.526,3.526,0,0,1,0,4.9l-2.731,2.731a3.526,3.526,0,0,1-4.9,0L86.189,208.216a3.526,3.526,0,0,1,0-4.9l2.731-2.731a3.526,3.526,0,0,1,4.9,0Z",
    transform: "translate(-85.2 -190.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164581",
    "data-name": "Path 164581",
    d: "M186.105,126.189a3.526,3.526,0,0,1,4.9,0l2.731,2.731a3.526,3.526,0,0,1,0,4.9l-20.716,20.622a3.526,3.526,0,0,1-4.9,0l-2.731-2.731a3.526,3.526,0,0,1,0-4.9Z",
    transform: "translate(-155.078 -125.2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentChecked);
export default __webpack_public_path__ + "static/media/payment-checked.fa51f2bbff241a7d36f85f2aea999bb6.svg";
export { ForwardRef as ReactComponent };